//退货API
import { baseUrl } from '@/config/env';
import request from '@/router/axios';
import { parseParam } from '@/util/util';

export const findReturnOrderList = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/returnOrder/findReturnOrderList?`+params,
        method: 'GET'
    })


}
export const findGoodsList = (supplyListNum) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/supplyList/findGoodsList/${supplyListNum}`,
        method: 'GET'
    })
}